import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import EthnicGroup from './ethnic-group';
import EthnicGroupDetail from './ethnic-group-detail';
import EthnicGroupUpdate from './ethnic-group-update';
import EthnicGroupDeleteDialog from './ethnic-group-delete-dialog';

const EthnicGroupRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<EthnicGroup />} />
    <Route path="new" element={<EthnicGroupUpdate />} />
    <Route path=":id">
      <Route index element={<EthnicGroupDetail />} />
      <Route path="edit" element={<EthnicGroupUpdate />} />
      <Route path="delete" element={<EthnicGroupDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EthnicGroupRoutes;
